/**
 * Transforms a saved product spotlight carousel from the database into the
 * form data structure. The GET endpoint returns field names that differ from
 * what the form / POST endpoint expect.
 *
 * @param {Object} carousel - Raw carousel object from the API.
 * @returns {Object} Form-compatible data.
 */
export function transformProductSpotlightToFormData(carousel) {
    // rankNumber is not a valid field for the PUT/POST endpoints
    const { rankNumber, ...rest } = carousel;

    return {
        ...rest,
        // Historically, API POST expects bgColor, but API GET returns backgroundColor
        ...(carousel.backgroundColor ? { bgColor: carousel.backgroundColor } : {}),
        ...(carousel.photoUrlMedium ? { imageUrl: carousel.photoUrlMedium } : {}),
        ...(carousel.linkTitle ? { linkText: carousel.linkTitle } : {}),
    };
}
